// Small helpers shared by the tour scripts.

export function path() { return (location.pathname || '/').toLowerCase().replace(/\/+$/, '') || '/'; }

/** Visible-element check (same rule the engine uses to pick targets). */
export function visible(sel) {
  try {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 1 && r.height > 1 && getComputedStyle(list[i]).visibility !== 'hidden') return list[i];
    }
  } catch (e) { /* bad selector */ }
  return null;
}

export function exists(sel) { try { return !!document.querySelector(sel); } catch (e) { return false; } }

export function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

function readCookie(name) {
  var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : '';
}

/**
 * UI hint only (which steps to show) - never used for anything security-related.
 * Same client-side read as credit-guard: commerce_features `acc` > 0 = signed in.
 */
export function loggedIn() {
  var jwt = readCookie('commerce_features');
  if (!jwt) return false;
  try {
    var b64 = jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    return Number(JSON.parse(atob(b64)).acc) > 0;
  } catch (e) { return false; }
}

export function isDesktop() { return window.matchMedia ? window.matchMedia('(min-width: 992px)').matches : window.innerWidth >= 992; }
